// NOTE: This file was automatically generated by a script. Do not modify this file manually.
// To regenerate this file, please use `pnpm scripts:microbootstrap-generator org_chart`
// The command will generate files in the 'frontend/artifacts' folder with the list of files using collections
import { PropsWithChildren } from 'react'

import {
  CollectionBootstrapConfig,
  CollectionsBootstrap as CoreCollectionsBootstrap,
} from 'modules/core/components/CollectionsBootstrap'
import companies from 'modules/core/store/collections/companies'
import legalEntities from 'modules/core/store/collections/legalEntities'
import users from 'modules/core/store/collections/users'

import atsCompanies from 'modules/ats/store/collections/atsCompanies'
import contractVersions from 'modules/contracts/store/collections/contractVersions'
import employeeGroups from 'modules/employees/store/collections/employeeGroups'
import employees from 'modules/employees/store/collections/employees'
import locations from 'modules/locations/store/collections/locations'

const CollectionsBootstrap = ({ children }: PropsWithChildren) => {
  const collections: CollectionBootstrapConfig[] = [
    [atsCompanies, {}] /* Referenced by 2 cases in this module */,
    [companies, {}] /* Referenced by 6 cases in this module */,
    [contractVersions, {}] /* Referenced by 3 cases in this module */,
    [employeeGroups, {}] /* Referenced by 1 cases in this module */,
    [employees, {}] /* Referenced by 10 cases in this module */,
    [legalEntities, {}] /* Referenced by 3 cases in this module */,
    [locations, {}] /* Referenced by 1 cases in this module */,
    [users, {}] /* Referenced by 4 cases in this module */,
  ] /* Generated file 👉 artifacts/org_chart-module-index.tsx-collection-dependencies-report-v2.json */

  return <CoreCollectionsBootstrap collections={collections}>{children}</CoreCollectionsBootstrap>
}

export default CollectionsBootstrap
